
import Vue from 'vue';
import throttle from 'lodash/throttle';
export default Vue.extend({
  props: {
    src: {
      type: String,
    },
    poster: {
      type: String,
    },
    vimeoID: {
      type: String,
      default: '',
    },
    isLoop: {
      type: Boolean,
      default: false,
      required: false,
    },
    ratio: {
      type: String,
      required: false,
      default: '3to2-to-16to9',
    },
    caption: {
      type: String,
    },
  },

  data() {
    return {
      consentForVimeoGiven: false,
      isPlayed: false as boolean,
      player: null as any,
      videoTemplate: '' as string,
      windowWidth: null as any,
      throttledResize: null as any,
      isMobile: false as boolean,
      isMounted: false as boolean,
    };
  },

  mounted() {
    this.throttledResize = throttle(this.checkVideoDevice, 600);
    this.initResizeEvent();
    this.checkVideoDevice();
    if (this.vimeoID && this.consentForVimeoGiven) {
      this.initVimeo();
    }
    this.isMounted = true;
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.throttledResize);
  },

  computed: {
    resizedPosterUrl() {
      if (this.poster && this.poster.length) {
        return `${this.poster}/m/1200x0/smart`;
      }
      return undefined;
    },
  },

  methods: {
    loadOrBlockVimeo(e: boolean): void {
      this.consentForVimeoGiven = e;
      e ? this.initVimeo() : null;
    },

    initVimeo() {
      const Plyr = require('plyr');
      const playerID = Math.random().toString(10).substr(2, 9);
      this.videoTemplate = `<div id="player${playerID}" data-plyr-provider="vimeo" data-plyr-embed-id="${this.vimeoID}" data-poster="${this.resizedPosterUrl}"></div>`;
      setTimeout(() => {
        this.player = new Plyr('#player' + playerID);
      }, 100);
    },

    onVideoPlay() {
      if (this.src) {
        this.isPlayed = true;
        this.player.setAttribute('controls', '');
        setTimeout(() => {
          this.player.play();
        }, 50);
      } else if (this.vimeoID) {
        this.isPlayed = true;
        this.player.play();
        if (this.isMobile === true) {
          this.player.fullscreen.enter();
        }
      }
    },

    initResizeEvent() {
      window.addEventListener('resize', this.throttledResize);
    },

    checkVideoDevice() {
      if (this.vimeoID) {
        if (this.windowWidth < 768) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      }
    },
  },
});

// functions
